<template>
    <app-layout>
        <Head>
            <title>Warenkorb</title>
        </Head>

        <template v-slot:overline>
            <translate>jetzt Bestellen</translate>
        </template>

        <template v-slot:headline>
            <translate>Ihr Warenkorb</translate>
        </template>

        <template v-slot:stepper>
            <stepper>
                <step icon="list-basket-checkmark">
                    <translate>Prüfen</translate>
                </step>
                <step icon="delivery-shipment-packages-setting">
                    <translate>Adresse und Zahlungsart</translate>
                </step>
                <step icon="credit-card-security-protection">
                    <translate>Bezahlen</translate>
                </step>
            </stepper>
        </template>

        <div class="checkout">
            <card class="checkout--success">
                <card-content>
                    <h5 v-translate>Ihr Warenkorb ist leer</h5>
                    <p v-translate>Fügen Sie ein Angebot zum Warenkorb hinzu:</p>
                    <form-link-button :route="this.$$route('dashboard')" color="primary">
                        <translate>Angebote auswählen</translate>
                    </form-link-button>
                </card-content>
            </card>
        </div>

    </app-layout>
</template>

<script>
import AppLayout from '@partfactory/Layouts/AppLayout';
import Stepper from '@partfactory/Shared/Stepper/Stepper';
import Step from '@partfactory/Shared/Stepper/Step';
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormLinkButton from '@partfactory/Shared/Form/FormLinkButton';

export default {
    name: 'Confirmation',
    components: {FormLinkButton, CardContent, Card, Step, Stepper, AppLayout },
    props: {},
};
</script>
